import React from 'react';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Stats from './components/Stats/Stats';
import Services from './components/Services/Services';
import WhyUs from './components/WhyUs/WhyUs';
import Clients from './components/Clients/Clients';
import CTA from './components/CTA/CTA';
import Footer from './components/Footer/Footer';

import AboutUsPage from './pages/AboutUsPage';
import CompanyProfilePage from './pages/CompanyProfilePage';
import CEOMessagePage from './pages/CEOMessagePage';
import WhyUsPage from './pages/WhyUsPage';
import SolutionsPage from './pages/SolutionsPage';
import CorporateSolutionPage from './pages/CorporateSolutionPage';
import ConsumerSolutionPage from './pages/ConsumerSolutionPage';
import GalleryPage from './pages/GalleryPage';
import PackagesPage from './pages/PackagesPage';
import OurTeamPage from './pages/OurTeamPage';
import ContactUsPage from './pages/ContactUsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ProductsPage from './pages/ProductsPage';

import useScrollReveal from './hooks/useScrollReveal';
import './styles/global.css';

const HomePage = () => (
  <main>
    <Hero />
    <Stats />
    <Services />
    <WhyUs />
    <Clients />
    <CTA />
  </main>
);

const routes = {
  '/': <HomePage />,
  '/about-us': <AboutUsPage />,
  '/company-profile': <CompanyProfilePage />,
  '/ceo-message': <CEOMessagePage />,
  '/why-us': <WhyUsPage />,
  '/solution': <SolutionsPage />,
  '/solutions': <SolutionsPage />,
  '/corporate-solution': <CorporateSolutionPage />,
  '/consumer-solution': <ConsumerSolutionPage />,
  '/products': <ProductsPage />,
  '/product': <ProductsPage />,
  '/gallery': <GalleryPage />,
  '/packages': <PackagesPage />,
  '/our-team': <OurTeamPage />,
  '/contact-us': <ContactUsPage />,
  '/privacy-policy': <PrivacyPolicyPage />,
};

function App() {
  useScrollReveal();

  const path = window.location.pathname.replace(/\/$/, '') || '/';
  const ActivePage = routes[path] || <HomePage />;

  return (
    <div className="app">
      <Navbar />
      {ActivePage}
      <Footer />
    </div>
  );
}

export default App;